var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49083 8.28746L9.49067 2.22998C9.49076 1.83586 9.17222 1.51732 8.77811 1.51741C8.38409 1.51741 8.06555 1.83594 8.06556 2.22996L8.06562 8.28754L2.00814 8.28738C1.61402 8.28747 1.29558 8.60591 1.29558 8.99993C1.2955 9.39405 1.61404 9.71259 2.00815 9.7125L8.06564 9.71265L8.06579 15.7701C8.0657 16.1643 8.38424 16.4828 8.77836 16.4827C8.97481 16.4828 9.15327 16.4031 9.28228 16.2741C9.41128 16.1451 9.49091 15.9667 9.49091 15.7702L9.49075 9.71267L15.5483 9.71273C15.7449 9.71273 15.9232 9.6331 16.0522 9.5041C16.1812 9.3751 16.2609 9.19673 16.2609 9.00018C16.261 8.60607 15.9424 8.28753 15.5483 8.28762L9.49083 8.28746Z",
    fill: "#1B203D",
    stroke: "#1B203D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cb8c23652bce71df1479cb0ea7d936b6.svg";
export { ForwardRef as ReactComponent };